import { api } from "../../lib";

export interface Abbreviation {
  id: string;
  shortcode: string;
  expansion: string;
  isActive: boolean;
  createdById: string | null;
  updatedById: string | null;
  createdBy: { id: string; fullName: string } | null;
  updatedBy: { id: string; fullName: string } | null;
  createdAt: string;
  updatedAt: string;
}

export interface ActiveAbbreviation {
  id: string;
  shortcode: string;
  expansion: string;
}

export interface CreateAbbreviationInput {
  shortcode: string;
  expansion: string;
  isActive?: boolean;
}

export interface UpdateAbbreviationInput {
  id: string;
  shortcode?: string;
  expansion?: string;
  isActive?: boolean;
}

export const abbreviationsService = {
  getAll: async () => {
    return api.get<Abbreviation[]>("/admin/abbreviations");
  },

  getActive: async () => {
    return api.get<ActiveAbbreviation[]>("/admin/abbreviations/active");
  },

  create: async (input: CreateAbbreviationInput) => {
    return api.post<Abbreviation>("/admin/abbreviations", input);
  },

  update: async (input: UpdateAbbreviationInput) => {
    const { id, ...updates } = input;
    return api.put<Abbreviation>(`/admin/abbreviations/${id}`, updates);
  },

  delete: async (id: string) => {
    await api.delete<void>(`/admin/abbreviations/${id}`);
  },
};
